<template>

<AppHead :title="$page.props.auth.account.name" />

<div class="pt-6 md:pt-0">
    <div v-if="episodes.length || sharedEpisodes.length" class="">

        <section class="mb-8 md:mb-12">
            <SectionHeading :title="greet" importance="1" class="px-4 xl:px-0">
                <Link :href="route('users.show', this.$page.props.auth.user.uuid)" class="md:hidden">
                    <div class="flex bg-white rounded-full items-center p-1">
                        <div class="pl-2 pr-1 text-gray-700">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                        </div>
                        <div class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-300 bg-center bg-cover border border-gray-400" :style="'background-image: url(' + this.$page.props.auth.user.avatar + ')'">
                            <div class="font-medium text-gray-800 text-sm" v-if="!this.$page.props.auth.user.avatar">
                                {{this.$page.props.auth.user.name.charAt(0) }}
                            </div>
                        </div>
                    </div>
                </Link>
            </SectionHeading>
            <div class="flex space-x-2.5 flex-nowrap w-full overflow-x-scroll hide-scroll-bar px-4 xl:px-0 -mt-4 md:mt-0">
                <Link :href="route('categories.show', category)" v-for="category in categories" class="inline-flex items-center justify-between px-7 md:px-9 bg-white py-3 md:py-4 md:text-lg rounded-full hover:bg-gray-400 transition-colors duration-100 ease-out active:bg-gray-500">
                    <div class="text-gray-800 font-medium text-center w-full whitespace-nowrap">
                        {{ category.name }}
                    </div>
                </Link>
            </div>

        </section>

        <section v-if="episodes.length" class="mb-8 md:mb-12">
            <SectionHeading title="Latest episodes" importance="1" class="px-4 xl:px-0">
                <Link :href="route('episodes.index')" class="flex space-x-1 items-center">
                    <div class="">
                        All episodes
                    </div>
                    <div class="">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
                    </div>
                </Link>
            </SectionHeading>
            <div class="relative flex space-x-4 flex-nowrap w-full overflow-x-scroll hide-scroll-bar px-4 xl:px-0 -mt-4 md:mt-0">
                <EpisodeCard v-for="episode in episodes" :episode="episode" />
            </div>
        </section>

        <section v-if="podcasts.length" class="px-4 xl:px-0 pb-24">
            <SectionHeading title="Shows for you" importance="1" />
            <div class="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
                <PodcastCard v-for="podcast in podcasts" :podcast="podcast"/>
            </div>
        </section>

        <section v-if="sharedEpisodes.length" class="mb-8 md:mb-12">
            <SectionHeading title="Shared with you" importance="1" class="px-4 xl:px-0">
            </SectionHeading>
            <div class="relative flex space-x-4 flex-nowrap w-full overflow-x-scroll hide-scroll-bar px-4 xl:px-0 -mt-4 md:mt-0">
                <EpisodeCard v-for="episode in sharedEpisodes" :episode="episode" />
            </div>
        </section>
    </div>

    <div v-else class="w-full flex flex-col space-y-8 items-center justify-center min-h-screen-ios min-h-screen text-gray-700 -mt-24">
        <div class="md:hidden absolute top-6 right-4 flex items-center space-x-3.5">
            <Link :href="route('accounts.show', this.$page.props.auth.account)" class="text-gray-800">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
            </Link>
            <Link :href="route('users.show', this.$page.props.auth.user.uuid)" class="">
                <div class="flex bg-white rounded-full items-center">
                    <!-- <div class="pl-2 pr-1 text-gray-700">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </div> -->
                    <div class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-300 bg-center bg-cover border border-gray-500" :style="'background-image: url(' + this.$page.props.auth.user.avatar + ')'">
                        <div class="font-medium text-gray-800 text-sm" v-if="!this.$page.props.auth.user.avatar">
                            {{this.$page.props.auth.user.name.charAt(0) }}
                        </div>
                    </div>
                </div>
            </Link>
        </div>

        <div class="">
            <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path></svg>
        </div>
        <div class="flex flex-col items-center justify-center space-y-5">
            <div class="text-4xl font-medium tracking-tight">
                Nothing here, yet.
            </div>
            <div v-if="$page.props.auth.user.roles.includes('super-admin') || $page.props.auth.user.roles.includes('owner') || $page.props.auth.user.roles.includes('admin') || $page.props.auth.user.roles.includes('creator')" class="">
                <Button :href="route('studio.index')" label="Get cracking" />
            </div>
        </div>

    </div>
</div>



</template>

<script>
    import Layout from '@/Shared/Layout'
    import SectionHeading from '@/Shared/SectionHeading'
    import Button from '@/Shared/Button'
    import EpisodeCard from '@/Shared/EpisodeCard'
    import PodcastCard from '@/Shared/PodcastCard'

    export default {
        components: { SectionHeading, Button, EpisodeCard, PodcastCard },
        props: {
            episodes: Object,
            templates: Object,
            podcasts: Object,
            categories: Object,
            greet: String,
            sharedEpisodes: Object,
        },
        layout: Layout,
    }
</script>
